import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Report, useGetScalingSize } from '@ui/Report';
import { DisplayValueData } from '@shared/helpers/display/get-display-value-data.helper';

const useStyles = makeStyles<{
  getScalingSize: ReturnType<typeof useGetScalingSize>;
}>()((theme, { getScalingSize }) => ({
  consumptionItem: {
    display: 'flex',
    alignItems: 'center',
    gap: getScalingSize(0.5),
  },
  legendDot: {
    margin: `auto ${getScalingSize(0.6)} auto ${getScalingSize(1)}`,
    width: getScalingSize(0.8),
    height: getScalingSize(0.8),
    borderRadius: '100%',
    flexShrink: 0,
  },
}));

type ConsumptionItemProps = {
  /** Energy in *kWh* */
  value: DisplayValueData;
  /** Row label */
  label: string;
  /** Color of the legend dot */
  color: string;
};

export const EnergyRow: React.FC<ConsumptionItemProps> = ({
  label,
  value,
  color,
}) => {
  const getScalingSize = useGetScalingSize();
  const { classes } = useStyles({ getScalingSize });

  return (
    <Box className={classes.consumptionItem}>
      <Box className={classes.legendDot} sx={{ backgroundColor: color }} />
      <Report.Text as="p">{label}</Report.Text>
      <Report.Text as="p" textAlign="right" sx={{ marginLeft: 'auto' }}>
        {value.value}
        <Report.Text color="text.subtle" as="span">
          &nbsp;{value.unit}
        </Report.Text>
      </Report.Text>
    </Box>
  );
};
